import React from "react";
import MaskedNationalId from "./MaskedNationalId";
import UserManagementDateTime from "./UserManagementDateTime";

const localizedName = (value, language) =>
  value?.[language === "ar" ? "nameAr" : "nameEn"] ||
  value?.name ||
  value?.nameEn ||
  value?.nameAr;

const localizedLocation = (account, language) => {
  const city = account?.location?.city || account?.governorate;
  const country =
    account?.location?.country || account?.country || city?.country;
  return [localizedName(country, language), localizedName(city, language)]
    .filter(Boolean)
    .join(language === "ar" ? "، " : ", ");
};

const formattedBirthDate = (value, language) => {
  const parsed = new Date(value);
  if (!value || Number.isNaN(parsed.getTime())) return "";
  return new Intl.DateTimeFormat(language === "ar" ? "ar-EG" : "en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(parsed);
};

const localizedGender = (value, text) => {
  if (!value) return "";
  return ({
    male: text.male,
    female: text.female
  })[String(value).toLowerCase()] || value;
};

const DetailItem = ({ label, value }) => (
  <div>
    <dt>{label}</dt>
    <dd>{value || "—"}</dd>
  </div>
);

const RegistrationAccountOverview = ({
  type,
  account,
  text,
  language,
  revealedNationalId = "",
  nationalIdLoading = false,
  onToggleNationalId
}) => {
  const customer = type === "customers";

  return (
    <dl className="account-detail-grid registration-review-detail-grid">
      {customer ? (
        <>
          <DetailItem
            label={text.customerName}
            value={account?.fullName || account?.name}
          />
          <DetailItem label={text.email} value={account?.email} />
          <DetailItem label={text.phone} value={account?.phone} />
          <DetailItem
            label={text.birthDate}
            value={formattedBirthDate(account?.dateOfBirth, language)}
          />
          <DetailItem
            label={text.gender}
            value={localizedGender(account?.gender, text)}
          />
          <div>
            <dt>{text.nationalId}</dt>
            <dd>
              <MaskedNationalId
                maskedValue={account?.maskedNationalId || account?.nationalId}
                value={revealedNationalId}
                loading={nationalIdLoading}
                onToggle={onToggleNationalId}
                text={text}
              />
            </dd>
          </div>
          <DetailItem
            label={text.location}
            value={localizedLocation(account, language)}
          />
        </>
      ) : (
        <>
          <DetailItem
            label={text.storeNameAr}
            value={account?.nameAr || account?.name}
          />
          <DetailItem label={text.storeNameEn} value={account?.nameEn} />
          <DetailItem label={text.email} value={account?.email} />
          <DetailItem
            label={text.ownerFullLegalName}
            value={account?.ownerFullLegalName}
          />
          <DetailItem label={text.phone} value={account?.phone} />
          <DetailItem
            label={text.registrationNumber}
            value={account?.registrationNumber}
          />
          <DetailItem
            label={text.category}
            value={localizedName(account?.category, language)}
          />
        </>
      )}
      <DetailItem
        label={text.registrationDate}
        value={(
          <UserManagementDateTime
            value={account?.registeredAt}
            language={language}
          />
        )}
      />
      <DetailItem label={text.accountIp} value={account?.registrationIp} />
    </dl>
  );
};

export default RegistrationAccountOverview;
